import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import PropTypes from 'prop-types';

const ShowcaseCountry = (props) => {
  const { category, id, country } = props;
  const params = new URLSearchParams(window.location.search);
  let header = '';
  if (params.get('header') === 'false') {
    header = '&header=false';
  }

  return (
    <Link
      to={`${category}/${country.replace(/ /g, '-').toLowerCase()}?id=${id}${header}`}
    >
      <div className='showcaseCountry'>
        <h1>{country}</h1>
      </div>
    </Link>
  );
};

ShowcaseCountry.propTypes = {
  country: PropTypes.string,
};

ShowcaseCountry.defaultProps = {
  country: '',
};

export default ShowcaseCountry;
